'use client';

import type { FeedbackStatus } from './api';
import { STATUS_LABELS } from './api';

export function StatusBadge({ status }: { status: FeedbackStatus }) {
  return (
    <span className={`feedback-status feedback-status--${status}`} data-status={status}>
      {STATUS_LABELS[status]}
    </span>
  );
}
